import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index.vue'
import companyIntroduction from '../views/companyIntroduction'
import productIntroduction from '../views/productIntroduction'
import helpTutorials from '../views/helpTutorials'
import contactUs from '../views/contactUs'
import privacyPolicy from '../views/privacyPolicy'
import newsDetail from '../views/newsDetail'
import newsList from '../views/newsList'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
      component: index
    },
    {
      path: '/index',
      name: 'idnex',
      component: index
    },
    {
      path: '/companyIntroduction',
      name: 'companyIntroduction',
      component: companyIntroduction
    },
    {
      path: '/productIntroduction',
      name: 'productIntroduction',
      component: productIntroduction
    },
    {
      path: '/helpTutorials',
      name: 'helpTutorials',
      component: helpTutorials
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js